/**
 * @file This file polyfills needed functionality for older browsers. It exports a single promise
 * that will resolve when all needed features are polyfilled.
 */
const promises = [];
if (window.TextDecoderStream == null || window.TextEncoderStream == null) {
    promises.push(import('@stardazed/streams-text-encoding').then(pkg => {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        window.TextDecoderStream = window.TextDecoderStream || pkg.TextDecoderStream;
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        window.TextEncoderStream = window.TextEncoderStream || pkg.TextEncoderStream;
    }));
}
export default Promise.all(promises).then(() => { });
